import { useState } from 'react';
import useLocalStorage from 'use-local-storage';
import englishMessage from '../translations/en.json';
import frenchMessage from '../translations/fr.json';
import { Language } from '../types/language.enum';

function useLanguage() {
  const [langFromStorage, setLanguageInStorage] = useLocalStorage<Language>(
    'language',
    navigator.language as Language,
  );

  const [language, setLanguage] = useState<Language>(langFromStorage);

  const getMessagesFromLang = (lang: Language) => (lang === 'en-US' ? englishMessage : frenchMessage);

  function changeLanguage(lang: Language) {
    setLanguage(lang);
    setLanguageInStorage(lang);
  }

  return { language, getMessagesFromLang, changeLanguage };
}

export default useLanguage;
